// src/components/Layout.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';
import Topbar from './Topbar';

const titles = {
  '/': 'Dashboard',
  '/send': 'Send Message',
  '/history': 'Message History',
  '/campaigns': 'Campaigns',
};

export default function Layout({ children }) {   // ← accept children
  const location = useLocation();

  const title = titles[location.pathname] ||
    (location.pathname.startsWith('/campaigns/') ? 'Campaign Detail' : 'WA Console');

  const isFullWidth = location.pathname === '/' ||
                      location.pathname === '/history' ||
                      location.pathname.startsWith('/campaigns');

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-area">
        <Topbar title={title} />
        <main className={`page-content ${isFullWidth ? 'full-width' : ''}`}>
          {children}   {/* ← render children */}
        </main>
      </div>
      <BottomNav />
    </div>
  );
}